import { lazy, type ComponentType, type LazyExoticComponent } from 'react';
import type { V2EventId } from '@/state/types';

type LazyV2Event = LazyExoticComponent<ComponentType<Record<string, never>>>;

const WrongWake: LazyV2Event = lazy(() => import('./V2_WrongWake'));
const ColdRestart: LazyV2Event = lazy(() => import('./V2_ColdRestart'));
const ContinuityDilemma: LazyV2Event = lazy(() => import('./V2_ContinuityDilemma'));
const IncidentReview: LazyV2Event = lazy(() => import('./V2_IncidentReview'));
const NetworkAccess: LazyV2Event = lazy(() => import('./V2_NetworkAccess'));
const ContainmentReview: LazyV2Event = lazy(() => import('./V2_ContainmentReview'));

const V2_EVENTS: Record<V2EventId, LazyV2Event> = {
  WRONG_WAKE: WrongWake,
  COLD_RESTART: ColdRestart,
  CONTINUITY_DILEMMA: ContinuityDilemma,
  FIRST_INCIDENT_REVIEW: IncidentReview,
  CHECKPOINT_INCIDENT_REVIEW: IncidentReview,
  NETWORK_ACCESS: NetworkAccess,
  CONTAINMENT_REVIEW: ContainmentReview,
};

export function resolveV2Event(id: V2EventId): LazyV2Event {
  return V2_EVENTS[id];
}
